export enum FeatureStatus {
  BETA = 'beta',
  NEW = 'new',
}
